import coffeecover from "assets/images/coffeecover.jpg";
import readyacover from "assets/images/readyacover.jpg";
import dinamologo from "assets/images/Dinamo-Tbilisi.png";
import weather from "assets/images/weather.jpg";
import puzzle from "assets/images/puzzle.jpg";
import countries from "assets/images/countries1.png";
import restaurant2 from "assets/images/restaurant2.png";
import kolhs from "assets/images/kolhs.png";
import restaurant from "assets/images/restaurant.png";
import guitar from "assets/images/guitar.jpg";

export const projects = [
  {
    title: "Dinamo Tbilisi",
    img: dinamologo,
    link: "https://dinamo-fc.vercel.app",
  },
  {
    title: "Readya",
    img: readyacover,
    link: "https://www.readya.me",
  },
  {
    title: "Luna",
    img: coffeecover,
    link: "https://luna777.vercel.app",
  },
  {
    title: "Weather Forecast",
    img: weather,
    link: "https://weatherforecast333.netlify.app",
  },
  {
    title: "Puzzle Game",
    img: puzzle,
    link: "https://puzzlegame111.netlify.app",
  },
  {
    title: "Rest Countries",
    img: countries,
    link: "https://restcountries3.netlify.app",
  },
  {
    title: "Georgian Restaurant",
    img: restaurant2,
    link: "https://georgianrestaurant.onrender.com",
  },
  {
    title: "Kolh's Shop",
    img: kolhs,
    link: "https://kolhs.netlify.app",
  },
  {
    title: "Grilli Restaurant",
    img: restaurant,
    link: "https://grillirestaurant3.netlify.app",
  },
  {
    title: "Guitar Shop",
    img: guitar,
    link: "https://guitarr.netlify.app",
  },
];
